import React from "react";
import button from "daisyui/components/button";


const Service = ({ SvgIcon, title, description, buttonText }) => {
    return(
        <div className="card bg-base-200 w-96 shadow-xl shadow-md mx-5 my-2 flex flex-col overflow-hidden">
            <figure className="bg-gray-100">
                <SvgIcon className="p-10 w-75 h-60" />
            </figure>
            <div className="card-body bg-blue-500">
                <h2 className="card-title text-white ">{title}</h2>
                <p className="text-gray-100">{description}</p>
                <div className="card-actions justify-end">
                <button data-theme={"dark"} className="btn rounded-2xl bg-blue-200 text-gray-800 my-3">{buttonText}</button>
                </div>
            </div>
        </div>
    ); 
};

export default Service; 